import { useEffect } from "react";
import { useLang } from "@/i18n";

// Sets document.title and re-applies whenever the title or active language changes.
export function usePageTitle(title) {
  const { lang } = useLang();
  useEffect(() => {
    if (title) document.title = title;
  }, [title, lang]);
}
